export enum PoniesModalType {
  DELETE_CARD = 'DELETE_CARD',
  CANCEL_CORE = 'CANCEL_CORE',
  ORDER_DETAILS = 'ORDER_DETAILS',
  PAYMENT_INFO = 'PAYMENT_INFO',
  CANCEL_SUBSCRIPTION = 'CANCEL_SUBSCRIPTION',
}
